<template>
<v-app>
    <v-app-bar flat app height="90" color="transparent">
      <v-spacer></v-spacer>
      <a href="https://pappyon.com/">
      <img class="mr-2" src="../assets/header-logo.svg" height="70"/>
      </a>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <slot/>
        <v-row>
          <v-sheet height="50"></v-sheet>
        </v-row>
      </v-container>
      <v-footer padless absolute height="50">
      <v-col
        class="text-center"
        cols="12"
      >
        <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
        <a class="text-caption grey--text mx-8 text-decoration-none" @click="openContactUrl">Contact</a>
        <a class="text-caption grey--text text-decoration-none" @click="openPrivacyPolicyUrl()">Privacy & Terms</a>
      </v-col>
    </v-footer>
    </v-main>
</v-app>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: mapGetters(['contactUrl', 'privacyPolicyUrl']),
    methods: {
      openContactUrl() {
        window.open(this.contactUrl);
      },
      openPrivacyPolicyUrl() {
          window.open(this.privacyPolicyUrl);
      },
    },
  }
</script>